<template>

    <v-multiselect
        :fixed="fixed"
        :items="tags"
        :model="val"
        :placeholder="$t('labels.select_tag')"
        @input="val = $event">
    </v-multiselect>

</template>

<script>

export default {

    props: {
        model: {
            required: true,
        },
        context: {
            type: String,
            default: 'review',
        },
        fixed: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            val: this.model !== null && this.model !== undefined ? this.model : [],
        }
    },

    computed: {

        tags() {
            return this.project.tags.filter(t => t.context === this.context).map(t => {
                return {
                    value: t.id,
                    label: t.name,
                    icon: t.sprite,
                    color: t.color,
                };
            });
        },

    },

    watch: {

        model(val) {
            this.val = val;
        },

        val(val) {
            this.$emit('input', val);
        },

    },

}

</script>
